import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { apiFetch } from '@/api/client'
import type {
  LoginFromBlockedIpQuery,
  LoginFromBlockedIpResult,
  LoginFromBlockedIpRow,
} from '@/features/logs/loginFromBlockedIpTypes'

/** Agent-API `POST /v1/loginFromBlockedIp/getLoginFromBlockedIps` request. */
export type GetLoginFromBlockedIpsRequest = {
  page?: number
  pageSize?: number
  /** Winner `keyword` / Backend-UI IP filter. */
  ip?: string
  player?: string
}

/** One Lab/Agent-API login-from-blocked-IP row. */
export type LoginFromBlockedIpApiRow = {
  id?: string
  _id?: string
  IP?: string
  ip?: string
  player?: string
  playerId?: string
  deviceId?: string
  createdAt?: string
  formattedDate?: string
}

/** Lab/Winner callback envelope from hierarchy-service. */
export type GetLoginFromBlockedIpsResponse = {
  value: boolean
  data: {
    dataArray?: LoginFromBlockedIpApiRow[]
    results?: LoginFromBlockedIpApiRow[]
    result?: LoginFromBlockedIpApiRow[]
    totalCount?: number
    total?: number
    totalItems?: number
    limit?: number
    count?: number
    maxRow?: number
    noOfPages?: number
    page?: number
  }
}

/**
 * Winner USER-V2 `LoginFromBlockedIp/getLoginFromBlockedIps` → Agent-API hierarchy.
 */
export async function getLoginFromBlockedIps(
  body: GetLoginFromBlockedIpsRequest = {},
): Promise<GetLoginFromBlockedIpsResponse> {
  const out: Record<string, unknown> = {
    page: body.page ?? 1,
    pageSize: body.pageSize ?? DEFAULT_PAGE_SIZE,
  }
  const ip = body.ip?.trim()
  const player = body.player?.trim()
  if (ip) out.ip = ip
  if (player) out.player = player

  return apiFetch<GetLoginFromBlockedIpsResponse>(
    '/v1/loginFromBlockedIp/getLoginFromBlockedIps',
    {
      method: 'POST',
      body: JSON.stringify(out),
    },
  )
}

/** Map hierarchy rows → console Login From Blocked IP table. */
export function toLoginFromBlockedIpResult(
  live: GetLoginFromBlockedIpsResponse,
  query: LoginFromBlockedIpQuery = {},
): LoginFromBlockedIpResult {
  const pageSize =
    live.data?.limit ??
    live.data?.count ??
    live.data?.maxRow ??
    query.pageSize ??
    DEFAULT_PAGE_SIZE
  const page = live.data?.page ?? query.page ?? 1
  const total =
    live.data?.totalCount ?? live.data?.total ?? live.data?.totalItems ?? 0
  const raw =
    live.data?.dataArray ?? live.data?.results ?? live.data?.result ?? []
  const rows: LoginFromBlockedIpRow[] = raw.map(mapRow)
  return { rows, total, page, pageSize }
}

function mapRow(row: LoginFromBlockedIpApiRow): LoginFromBlockedIpRow {
  return {
    id: String(row.id ?? row._id ?? ''),
    ip: String(row.IP ?? row.ip ?? ''),
    player: String(row.player ?? ''),
    createdAt: String(row.createdAt ?? row.formattedDate ?? ''),
  }
}
